var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6613 11.276V13.2753C14.662 13.4609 14.624 13.6446 14.5496 13.8146C14.4753 13.9847 14.3662 14.1373 14.2295 14.2628C14.0927 14.3883 13.9312 14.4838 13.7554 14.5433C13.5796 14.6027 13.3933 14.6248 13.2084 14.6081C11.1577 14.3853 9.18787 13.6845 7.45716 12.5622C5.84695 11.539 4.48177 10.1738 3.45858 8.56359C2.33229 6.82501 1.63139 4.84558 1.41264 2.78565C1.39598 2.60136 1.41788 2.41562 1.47695 2.24026C1.53601 2.06489 1.63094 1.90375 1.75569 1.76709C1.88044 1.63042 2.03229 1.52123 2.20155 1.44647C2.37081 1.3717 2.55379 1.333 2.73883 1.33283H4.73812C5.06154 1.32965 5.37509 1.44417 5.62032 1.65507C5.86554 1.86596 6.02572 2.15883 6.07098 2.47909C6.15537 3.1189 6.31186 3.74712 6.53748 4.35176C6.62715 4.59029 6.64655 4.84952 6.5934 5.09874C6.54025 5.34797 6.41677 5.57673 6.23759 5.75792L5.39122 6.60429C6.33992 8.27273 7.72136 9.65417 9.3898 10.6029L10.2362 9.7565C10.4174 9.57732 10.6461 9.45384 10.8953 9.40069C11.1446 9.34754 11.4038 9.36695 11.6423 9.45661C12.247 9.68223 12.8752 9.83873 13.515 9.92311C13.8387 9.96878 14.1344 10.1318 14.3457 10.3813C14.5571 10.6307 14.6694 10.9491 14.6613 11.276Z",
    stroke: "#64748B",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.ffd54f3e54862807e5dfc283cf242b47.svg";
export { ForwardRef as ReactComponent };